<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <v-card
    flat
    class="secondary fill-height pa-12"
    height="25%">
      <v-form
      ref="form"
      lazy-validation
      >
      <v-list class="secondary" max-width="1000px">
        <v-subheader class="display-1 grayBold--text">
          {{$t("add_client")}}
        </v-subheader>
              <v-list-item>
          <v-list-item-content class="grayBold--text">
              <v-list-item-title class="overline grayBold--text">
                {{ $t("information_uppercase") }}
              </v-list-item-title>
              <v-flex xs12 sm6 md4>
                <v-text-field class="mr-5" required :rules="firstnameRule" light v-model="clientModel.firstname" :label="$t('firstname')" />
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field class="mr-5" required :rules="lastnameRule" light v-model="clientModel.lastname" :label="$t('lastname')" />
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-text-field light :rules="emailRule" v-model="clientModel.email" :label="$t('email')" />
              </v-flex>
                  <v-list-item-title class="justify-space-between overline grayBold--text py-3 ml-3">
                    {{ $t("clientSideviewContactsUppercase") }}
                    <v-btn
                      elevation="2"
                      icon
                      small
                      color="primary"
                      @click="addPhone()"
                    >
                      <v-icon>
                      mdi-plus
                      </v-icon>
                    </v-btn>
                  </v-list-item-title>

                <!-- <div v-for="contact in clientModel.contacts" :key="contact.id">
                  <v-autocomplete
                      light
                      class="grayBold--text mr-5"
                      v-model="contact.contact_type_id"
                      :items="contactTypeCombo"
                      item-text="contact_info_type"
                      :label="$t('contact_type')"       
                      return-object
                      required 
                      :rules="contactTypeRule"
                  />
                  <v-text-field light required :rules="phoneRule" v-model="contact.phone" :label="$t('phone')" />
                </div> -->
                <div class="contact-item">
                  <div
                    class="d-flex mt-1"
                    v-for="contact, index in clientModel.contacts"
                    :id="`${index}`"
                    :key="index"
                  >
                  <v-checkbox
                        v-if="contact.is_primary === true"
                        color="primary"
                        readonly
                        light
                        class="grayBold--text mr-5 pt-4"
                        dense
                        v-model="contact.is_primary"
                        :label="$t('is_primary')"
                        @change="onCheckboxChange($event, contact)"
                      ></v-checkbox>
                      <v-checkbox
                        v-if="contact.is_primary === false"
                        light
                        class="grayBold--text mr-5 pt-4"
                        dense
                        v-model="contact.is_primary"
                        :label="$t('is_primary')"
                        @change="onCheckboxChange($event, contact)"
                      ></v-checkbox>
                        <v-autocomplete
                        light
                        class="grayBold--text mr-5 dropdown"
                        v-model="contact.contact_type"
                        :items="contactTypeCombo"
                        item-text="contact_info_type"
                        :label="$t('contact_type')"       
                        return-object
                        required 
                        :rules="contactTypeRule"
                        />
                    <v-flex xs12 sm6 md2>
                        <v-text-field light required :rules="phoneRule" v-model="contact.phone" :label="$t('phone')" />
                    </v-flex>
                    <v-btn
                      color="error"
                      class="mt-1 ml-4"
                      fab
                      small
                      @click="deletePhone(index)"
                      >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn> 
                  </div>
                </div>
              
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          depressed
          right
          light
          color="grayBold--text secondary"
          @click="hideModal()"
        >
          {{$t("cancel")}} 
        </v-btn>
        <v-btn
          color="primary"
          depressed
          right
          large
          class="modal-logout"
          @click="doAddClient"><v-icon left>mdi-plus</v-icon>{{$t("add")}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, clientsModule } from '@/store/modules/store-accessor'
import { primaryContactExists } from '@/helpers/data';

@Component
export default class AddClientModal extends Vue {
  @Prop()
  payload!: any;

  clientModel = {
    firstname: "", 
    lastname: "",
    email: "",
    id: "",
    contacts: [{
        id: Math.random() * -1, //Need Random and non-integer and also negative, for this to work with the backend properly
        contact_type: { contact_info_type: "", id: 0 },
        contact_type_id: 0,
        is_primary: true,
        description: '',
        phone: ''
    }]
  }

  get contactTypeCombo() {
    for (let i = 0; i < commonModule.contactTypeCombo.length; i++) {
      (commonModule.contactTypeCombo[i]["contact_info_type"] as any) = this.$t(commonModule.contactTypeCombo[i]["contact_info_type"]);
    }
    return commonModule.contactTypeCombo;
  }

  firstnameRule= [
    (val: any) => !!val || this.$i18n.t("firstname_required"),
    (val: any) => val.length <= 45 || this.$i18n.t("client_form_name_length_rule"),
  ]
  lastnameRule= [
    (val: any) => !!val || this.$i18n.t("lastname_required"),
    (val: any) => val.length <= 45 || this.$i18n.t("client_form_lastname_length_rule"),
  ]
  emailRule:any =[
    (val: any) => val.length <= 70 || this.$i18n.t("client_form_email_length_rule"),
    (val: any) => {
      //eslint-disable-next-line
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
      if(val.length > 0) return reg.test(val) || this.$i18n.t("form_email_rule");
      else return true;
    },
  ]
  contactTypeRule= [
    (val: any) => (val || '').contact_info_type.length > 0 || this.$i18n.t("contact_type_required"),
  ]
  phoneRule= [
    (val: any) => !!val || this.$i18n.t("phone_required"),
    (val: any) => val.length <= 15 || this.$i18n.t("client_form_phone_length_rule"),
  ]

  onCheckboxChange(ev: any, item: any) {
    if(ev === true) {
        this.clientModel.contacts.forEach((element: any) => 
        {
          if (element.id === item.id) {
            element.is_primary = true;
          }
          else {
            element.is_primary = false;
          }
        });
    }

  }

  async hideModal () {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
  }

  addPhone() {
    let newContact = {
        id: Math.random(),
        contact_type: { contact_info_type: "", id: 0 },
        contact_type_id: 0,
        is_primary: false,
        description: '',
        phone: ''
    } as any

    this.clientModel.contacts.push(newContact);
  }

  deletePhone(index: number) {
    if (this.clientModel.contacts.length > 1) {
      this.clientModel.contacts.splice(index, 1);
      if (!primaryContactExists(this.clientModel)) {
        this.clientModel.contacts[index].is_primary = true;
      }
    }
  }

  doAddClient () {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.clientModel.contacts.map((item) => {
        item.contact_type_id = item.contact_type.id
      })

      clientsModule.addClient(this.clientModel);
      this.hideModal();
    } 
  }
};
</script>

<style lang="scss" scoped>
.contact-item {
  // width: 200px;
  max-height: 400px;
  overflow: auto;
  padding-right: 20px;
}

.dropdown{
  max-width: 250px;
}
</style>


